var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M26 29H28V43H26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M34 42L32 42 26 34 28 34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M20 42L22 42 28 34 26 34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M27,30L27,30c-1.7,0-3-1.3-3-3v-4h6v4C30,28.7,28.7,30,27,30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M6.7 23.6H8.7V31.6H6.7z",
    transform: "scale(-1) rotate(-27.057 -114.856 32.055)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M24 32H30V34H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CAF9",
    d: "M38.9 5.699999999999999A2 6 0 1 0 38.9 17.7A2 6 0 1 0 38.9 5.699999999999999Z",
    transform: "rotate(-27.057 38.917 11.696)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M37.9 4.7H39.9V18.7H37.9z",
    transform: "scale(-1) rotate(-27.057 -48.613 161.753)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M18.3 15.7H20.3V27.7H18.3z",
    transform: "scale(-1) rotate(-27.057 -90.252 80.229)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M8.3 23H13.3V29H8.3z",
    transform: "scale(-1) rotate(-27.057 -108.232 45.025)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M19.1 10.7H39.1V22.7H19.1z",
    transform: "scale(-1) rotate(-27.057 -69.432 120.99)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M15.8,28l4.5-2.3l-3.6-7.1l-4.5,2.3c-0.5,0.3-0.7,0.9-0.4,1.3l2.7,5.3C14.7,28.1,15.3,28.3,15.8,28z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M27 26A1 1 0 1 0 27 28A1 1 0 1 0 27 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.93dfd21bb6f5090d2fec93791a3dbebd.svg";
export { ForwardRef as ReactComponent };